exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1st2xmrxmbQy0ayutBugLU{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:1.42857rem;width:100%}._3rildP10KCwacoYaGHGI3d{width:100%}._12dsW6e2TMTEwvwtOUBBKX{padding:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Note": "_1st2xmrxmbQy0ayutBugLU",
	"Note_wrapper": "_3rildP10KCwacoYaGHGI3d",
	"Note_card": "_12dsW6e2TMTEwvwtOUBBKX"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Student/Note/style.postcss
// module id = 1323
// module chunks = 0